import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { Input } from '@flipster/ui';
import { numberFormatter } from '@flipster/utils/num';

import { tradeSymbolBunja } from '@web/app/[locale]/(web)/trade/_misc/symbol';

import { spotFormBunja } from '../bunja/form';
import { formItem, label, labelWrapper } from '../styles';

const PriceForm = () => {
  const transTrade = useTranslations('Trade.r250401');

  const { symbolInfoWithDefaultAtom } = useBunja(tradeSymbolBunja);
  const { bboPriceAtom } = useBunja(spotFormBunja);

  const symbolInfo = useAtomValue(symbolInfoWithDefaultAtom);
  const bboPrice = useAtomValue(bboPriceAtom);

  const { pricePrecision } = symbolInfo;
  const marketPrice = numberFormatter(bboPrice, {
    precision: pricePrecision,
    method: 'round-half-up',
    toFixed: true,
  });

  return (
    <>
      <div className={labelWrapper}>
        <span className={label}>{transTrade('Market_price')}</span>
      </div>
      <div className={formItem}>
        <Input
          placeholder={transTrade('Market_price_executed_at_price', {
            price: marketPrice,
          })}
          disabled
        />
      </div>
    </>
  );
};

export default PriceForm;
